<template>
    <button class="button" :class="'button-' + type" :style="`width: ${width}; height: ${height};`" :disabled="disabled">
      {{ title }}
      <span class="play-icon" v-if="hasPlayIcon">
        <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.25 4.76314C8.91667 5.14804 8.91667 6.11029 8.25 6.49519L1.5 10.3923C0.833333 10.7772 -4.50056e-07 10.2961 -4.16407e-07 9.52628L-7.57103e-08 1.73205C-4.20613e-08 0.96225 0.833333 0.481125 1.5 0.866025L8.25 4.76314Z" fill="currentColor"/>
        </svg>
      </span>
    </button>
</template>

<script>
export default {
  name: 'app-button',
  props: {
    title: String,
    type: String,
    width: {
      type: String,
      default: '160px'
    },
    height: {
      type: String,
      default: '40px'
    },
    hasPlayIcon: Boolean,
    disabled: Boolean
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $color__white;
  border-radius: 3px;
  padding: 10px 15px;
  transition: .3s;
  cursor: pointer;
  user-select: none;
  font-family: $font_main;

  &[disabled] {
    background: $color__smoke;
    color: $color__gray;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }
}

.button-main {
  background: $color__orange;
  box-shadow: 0 2px 2px #C6523B;

  &:active {
    box-shadow: inset 0px 4px 4px rgba(128, 37, 15, 0.54);
  }
}

.button-second {
  background: $button_color_second;
  box-shadow: 0px 2px 2px #4C095C;

  &:active {
    box-shadow: inset 0 4px 4px rgba(44, 4, 48, 0.54);
  }
}

.button-third {
  background: $button_color_third;
  box-shadow: 0 2px 2px #13557C;

  &:active {
    box-shadow: inset 0 4px 4px #0E476A;
  }
}

.button-fourth {
  background: $button_color_fourth;
  box-shadow: 0 2px 2px #557428;

  &:active {
    box-shadow: inset 0 4px 4px #557428;
  }
}

.button-alt {
  background: $color__white;
  color: $color__copper-pink;
  border: 1px solid $color__copper-pink;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.42);

  &[disabled] {
    border: none;
  }

  &:active {
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.45);
  }
}

.button-gray {
  background: $color_controls;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.42);

  &:active {
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.45);
  }
}

.play-icon {
  margin-left: 8px;
}
</style>
